// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4UG2H","index":"styles_index__1sn_m"};